// DPS-4707: the healing agent records on review_context
//   old_selectors_removed: [{ entry_index, selector }]  (empty when the fix keeps every old selector)
//   old_selector_removal_reason: string                 (only beside a removal, when the agent gave one)
// Such a fix can stop older pages extracting once they are re-extracted after merge, so the agent
// holds it from auto-merge (reason code old_selector_removed) and the reviewer is warned here.
// Older jobs and agent versions have neither field and must render exactly as before.

/**
 * The removed old selectors to show a reviewer, or null when there is nothing to show
 * (field missing, empty, or malformed). Items without a non-empty string selector are skipped.
 */
export function removedOldSelectors(ctx) {
  const raw = ctx?.old_selectors_removed;
  if (!Array.isArray(raw)) return null;
  const selectors = raw
    .filter((item) => item && typeof item === 'object' && typeof item.selector === 'string' && item.selector.trim())
    .map((item) => ({
      entryIndex: Number.isInteger(item.entry_index) ? item.entry_index : null,
      selector: item.selector,
    }));
  if (selectors.length === 0) return null;
  const reasonRaw = ctx.old_selector_removal_reason;
  const reason = typeof reasonRaw === 'string' && reasonRaw.trim() ? reasonRaw.trim() : null;
  return { selectors, reason };
}
